export const getTranslationByKeyFromMap = (intl, map) => (value) => intl.formatMessage({
  ...(map[value] || map.spaceSymbol),
});
